import './_datetimepicker.scss';
import './_datetimepicker.dark-mode.scss';
import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';

// eslint-disable-next-line import/extensions
import '../../../services/libs/bootstrap-datetimepicker.js';

const DatePicker = ({ defaultDate, value, minDate, maxDate, setFieldValue, id, fieldName }) => {
  const inputRef = useRef(null);

  const [datePickerValue, setDatePickerValue] = useState(value);

  useEffect(() => {
    $(inputRef.current)
      .datetimepicker({
        defaultDate,
        format: 'YYYY-MM-DD',
        minDate,
        maxDate,
      })
      .on('dp.hide', () => {
        const inputValue = $(inputRef.current).val();
        if (inputValue) {
          setDatePickerValue((prevState) => {
            if (!prevState) {
              setFieldValue(fieldName, inputValue);
              return inputValue;
            }
          })
        }
      })
      .on('dp.change', (e) => {
        if (e?.date) {
          setFieldValue(fieldName, e.date.format('YYYY-MM-DD'));
          setDatePickerValue(e.date.format('YYYY-MM-DD'));
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <input
      type="text"
      name={fieldName || ''}
      className="form-control date-picker"
      ref={inputRef}
      id={id || null}
      autoComplete="off"
      value={datePickerValue}
      onChange={(e) => setDatePickerValue(e.target.value)}
    />
  );
};

DatePicker.propTypes = {
  defaultDate: PropTypes.string,
  value: PropTypes.string,
  minDate: PropTypes.string,
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  setFieldValue: PropTypes.func,
  id: PropTypes.string,
  fieldName: PropTypes.string,
};

export default DatePicker;
